import config from "config";
import API from "./http";

import { getIdentifierHeaders } from "@zuldigital/utils";

const user = {
  requestOtp(phoneNumber, currentToken) {
    const city = localStorage.getItem("X-City");
    const data = new FormData();

    if (phoneNumber) {
      data.append("phoneNumber", phoneNumber);
    }

    const headers = {
      ...getIdentifierHeaders(),
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Origin": "WEB_APP",
    };

    if (city) {
      headers["X-City"] = localStorage.getItem("X-City");
    }

    if (currentToken) {
      headers["Authorization"] = `Bearer ${currentToken}`;
    }

    return API.post(`${config.ZUL_API_URL}/user/request-otp`, data, {
      headers,
    });
  },
  create(user, city) {
    const headers = {
      ...getIdentifierHeaders(),
      "X-Origin": "WEB_APP",
    };

    if (city) {
      headers["X-City"] = city;
    }

    return API.post(`${config.ZUL_API_URL}/user`, user, { headers });
  },
};

export default user;
